import { useEffect } from "react";
import useHistory from "routing/useHistory";
import Routes from "./common/Routes";
const O365InputConfiguration = ({ url = Routes.INTEGRATIONS.O365.ACTIVITYAPI.index }) => {
  const history = useHistory();
  useEffect(() => {
    history.push(url);
  }, [history, url]);
  return null;
};
export default O365InputConfiguration;
